import React from 'react'
import DocumentViewer from '../../Component/DynamicDocViewer/Doc_Viewer'

const FacultyComponent = () => {
  const facultyListDocument = {
    pathurl: 'dbradc/Academics/FacultyList/Degree faculty list.pdf',
    filename: 'Degree Faculty List',
  }
  return (
    <div>
      <DocumentViewer selectedDocData={facultyListDocument} />
    </div>
  )
}
export default FacultyComponent
